// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnFiller_root__2_B1d"};